import React, { useEffect, useState } from "react";
import SupplierTypeTabContent from "./OBTabsScreens/SupplierTypeTabContent";
import PersonalDetailsTabContent from "./OBTabsScreens/PersonalDetailsTabContent";
import ExperienceOfferedTabContent from "./OBTabsScreens/ExperienceOfferedTabContent";
import BusinessDetailsTabContent from "./OBTabsScreens/BusinessDetailsTabContent";
import { useGetUserProfileQuery } from "../../../rtk-query/slices/profile/profileSlice";
import {
  useGetCitiesQuery,
  useGetCountriesQuery,
  useGetSupplierDestinationQuery,
} from "../../../rtk-query/slices/select-options/selectOptionsSlice";
import AccountDetailsTabContent from "./OBTabsScreens/AccountDetailsTabContent";

function OBTabBar() {
  const { data: userProfile } = useGetUserProfileQuery();
  const { data: cityData } = useGetCitiesQuery();
  const { data: countryData } = useGetCountriesQuery();
  const { data: jobTitleOptionsData } = useGetSupplierDestinationQuery();
  const [currentTab, setCurrentTab] = useState(
    userProfile?.data?.supplier?.on_boardings
      ? userProfile?.data?.supplier?.on_boardings + 1
      : 1
  );

  useEffect(() => {
    if (userProfile?.data?.supplier?.on_boardings) {
      setCurrentTab(userProfile?.data?.supplier?.on_boardings + 1);
    }
  }, [userProfile]);

  const totalTabs = [
    {
      id: 1,
      name: "Supplier Type",
      component: <SupplierTypeTabContent setCurrentTab={setCurrentTab} />,
    },
    {
      id: 2,
      name: "Business Details",
      component: <BusinessDetailsTabContent setCurrentTab={setCurrentTab} />,
    },
    {
      id: 3,
      name: "Experience offered",
      component: <ExperienceOfferedTabContent setCurrentTab={setCurrentTab} />,
    },
    {
      id: 4,
      name: "Personal details",
      component: <PersonalDetailsTabContent setCurrentTab={setCurrentTab} />,
    },
    {
      id: 5,
      name: "Account details",
      component: <AccountDetailsTabContent setCurrentTab={setCurrentTab} />,
    },
  ];

  return (
    <section className="ob-tab-bar-container p-4">
      <div className="ob-tab-bar-wrapper">
        <div className="ob-tab-bar d-flex align-items-center  gap-4 pt-2 pb-2 ps-4 pe-4">
          {totalTabs.map((tab, index) => {
            let canClick =
              userProfile?.data?.supplier?.on_boardings + 1 >= index + 1;
            return (
              <div
                key={tab.id}
                className={`d-flex align-item-center gap-2  ob-tab-bar-item  ${
                  !canClick && "ob-tab-bar-item-fade"
                }`}
                onClick={() => {
                  if (
                    userProfile?.data?.supplier?.on_boardings + 1 >=
                    index + 1
                  ) {
                    setCurrentTab(tab.id);
                  }
                  // setCurrentTab(tab.id);
                }}
              >
                <div
                  className={`ob-tab-bar-number  ${
                    currentTab >= index + 1 ? "ob-tab-bar-number-active" : ""
                  }`}
                >
                  {index + 1}
                </div>
                <p
                  className={`m-0  ${
                    currentTab >= index + 1
                      ? "ob-tab-bar-text-active"
                      : "ob-tab-bar-text"
                  }`}
                >
                  {tab.name}
                </p>
                {totalTabs?.length !== tab?.id && (
                  <p
                    className={`m-0  ${
                      currentTab >= index + 1
                        ? "ob-tab-bar-dots-active"
                        : "ob-tab-bar-dots"
                    }`}
                  >
                    .................
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {totalTabs[currentTab - 1]?.component}
    </section>
  );
}

export default OBTabBar;
